import { Children } from 'react';
import { Box, Typography } from '@mui/material';

import { getThemeColor } from '../../utils/common';
import { FORTA_WHITE } from '../../utils/colors';
import { Themes } from '../../constants';

import type { ReactNode } from 'react';
import type { ITableHeaderConfig } from '../../utils/types';

interface FTableContainerProps {
  children?: ReactNode;
  colorTheme?: Themes;
  sx?: any;
  headerStyle?: any;
  contentStyle?: any;
  headerConfig?: Array<ITableHeaderConfig>;
}

function FTableContainer(props: FTableContainerProps) {
  const {
    children,
    sx,
    headerStyle = {},
    contentStyle = {},
    headerConfig,
    colorTheme = Themes.Primary,
  } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: getThemeColor(colorTheme).light3,
        borderRadius: '10px',
        boxShadow: `0px 4px 4px ${getThemeColor(colorTheme).light2}`,
        ...sx,
      }}
    >
      {Boolean(headerConfig?.length) && (
        <Box
          sx={{
            display: 'flex',
            backgroundColor: getThemeColor(colorTheme).primary,
            borderRadius: '10px 10px 0 0',
            boxShadow: `0px 4px 4px ${getThemeColor(colorTheme).light2}`,
            height: 40,
            flexGrow: 1,
            width: 'calc(100% + 4px)',
            marginLeft: '-2px',
            px: 3,
            ...headerStyle,
          }}
        >
          {headerConfig?.length &&
            headerConfig?.map((conf: ITableHeaderConfig) => {
              return (
                <Box
                  sx={{ display: 'flex', py: 0.5, alignItems: 'center', ...conf.sx }}
                  key={conf.label}
                >
                  <Typography
                    variant={conf.labelWeight ? conf.labelWeight : 'body1'}
                    textAlign={conf.labelAlign ? conf.labelAlign : 'center'}
                    sx={{ flexGrow: 1 }}
                    color={FORTA_WHITE}
                  >
                    {conf.label}
                  </Typography>
                  {conf.showRightBorder && (
                    <Box
                      sx={{
                        height: '100%',
                        borderLeft: `1px solid ${getThemeColor(colorTheme).light2}`,
                        borderRadius: '4px',
                      }}
                    ></Box>
                  )}
                </Box>
              );
            })}
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '0 0 10px 10px',
          overflow: 'hidden',
          '& .table-row:nth-of-type(1n)': {
            backgroundColor: getThemeColor(colorTheme).light3,
          },

          '& .table-row:nth-of-type(2n)': {
            backgroundColor: FORTA_WHITE,
          },
          ...contentStyle,
        }}
      >
        {Children.map(children, (child) => (
          <Box className="table-row">{child}</Box>
        ))}
      </Box>
    </Box>
  );
}

export default FTableContainer;
